var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.22607C6.275 4.22607 4.875 5.62607 4.875 7.35107C4.875 9.07607 6.275 10.4761 8 10.4761C9.725 10.4761 11.125 9.07607 11.125 7.35107C11.125 5.62607 9.725 4.22607 8 4.22607ZM8 9.22607C6.96667 9.22607 6.125 8.38441 6.125 7.35107C6.125 6.31774 6.96667 5.47607 8 5.47607C9.03333 5.47607 9.875 6.31774 9.875 7.35107C9.875 8.38441 9.03333 9.22607 8 9.22607ZM8 0.601074C3.5125 0.601074 0 4.11357 0 8.60107C0 13.1011 3.52917 16.6011 8 16.6011C12.475 16.6011 16 13.0969 16 8.60107C16 4.11357 12.4875 0.601074 8 0.601074ZM8 15.3511C6.53333 15.3511 5.1875 14.9052 4.09167 14.1386C4.82917 12.6802 6.34583 11.7261 8 11.7261C9.65417 11.7261 11.175 12.6802 11.9083 14.1386C10.8125 14.9052 9.46667 15.3511 8 15.3511ZM12.8833 13.3052C12.475 12.5969 11.9208 11.9802 11.2375 11.5011C10.2875 10.8302 9.16667 10.4761 8 10.4761C6.83333 10.4761 5.7125 10.8302 4.7625 11.5011C4.08333 11.9802 3.525 12.5927 3.11667 13.3052C1.95417 12.0969 1.25 10.4469 1.25 8.60107C1.25 4.81774 4.21667 1.85107 8 1.85107C11.7833 1.85107 14.75 4.81774 14.75 8.60107C14.75 10.4469 14.0458 12.0969 12.8833 13.3052Z",
    fill: "url(#paint0_linear_0_92)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_92",
    x1: 1.77777,
    y1: 16.8366,
    x2: 15.0216,
    y2: 2.7653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.7070ef7623ee616fcfb3cc0bcdf0f74a.svg";
export { ForwardRef as ReactComponent };